/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaUnsubscribeViewProps } from './citta-unsubscribe';

export default (props: ICittaUnsubscribeViewProps) => {
    const { unsubscribeContainer, alertMessage, unsubscribeHeading, unsubscribeInput, unsubscribeButton } = props;
    return (
        <Module {...unsubscribeContainer}>
            {alertMessage}
            {unsubscribeHeading}
            {unsubscribeInput}
            {unsubscribeButton}
        </Module>
    );
};